import React from 'react';
import { Box, Typography, Container } from '@mui/material';
import { useTranslation } from 'react-i18next'; // 1. Import hook
import videoBackground from '../assets/video/desti.mp4';

const CustomTripSection = () => {
  const { t } = useTranslation(); // 2. Initialize translation function

  return (
    <Box
      component="section"
      sx={{
        position: 'relative',
        width: '100vw',
        height: { xs: '70vh', md: '80vh' },
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        overflow: 'hidden',
        color: 'white',
      }}
    >
      {/* 1. The Video Background */}
      <Box
        component="video"
        autoPlay
        loop
        muted
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          objectFit: 'cover',
          zIndex: 1,
        }}
      >
        <source src={videoBackground} type="video/mp4" />
        {t('destinations_hero_video_fallback')} {/* 3. Use translation */}
      </Box>

      {/* 2. The Dark Overlay */}
      <Box
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          backgroundColor: 'rgba(0, 0, 0, 0.4)',
          zIndex: 2,
        }}
      />

      {/* 3. The Content */}
      <Container
        maxWidth="md"
        sx={{
          position: 'relative',
          zIndex: 3,
          textAlign: 'center',
        }}
      >
        <Typography
          variant="h1"
          component="h1"
          sx={{
            fontFamily: '"Cormorant Garamond", "Georgia", serif',
            fontWeight: 700,
            fontSize: { xs: '3rem', sm: '4rem', md: '5rem' },
            lineHeight: 1.1,
            mb: 3,
            textShadow: '0 2px 10px rgba(0,0,0,0.5)',
          }}
        >
           {t('destinations_hero_headline')} {/* 3. Use translation */}
        </Typography>
        <Typography
          variant="h6"
          component="p"
          sx={{
            fontFamily: '"Lato", "Helvetica", "Arial", sans-serif',
            maxWidth: '650px',
            mx: 'auto',
            color: 'rgba(255, 255, 255, 0.9)',
            lineHeight: 1.7,
            textShadow: '0 1px 5px rgba(0,0,0,0.4)',
            fontSize: { xs: '1rem', md: '1.15rem' },
          }}
        >
          {t('destinations_hero_paragraph')} {/* 3. Use translation */}
        </Typography>
      </Container>
    </Box>
  );
};

export default CustomTripSection;